module.exports = __webpack_public_path__ + "img/icp.d0289dc0.png";